import axios from 'axios';
import aesEncryptionService from '../services/aesEncryptionService';
import appConfig from '../config/appConfig';
import { debug } from 'console';

interface EncryptedApiResponse {
  encryptedBody: string;
}

interface DecryptedResponse {
  UserName?: string;
  Mobile?: string;
  Result?: string;
  [key: string]: any;
}
interface ForgotRequestResponse {
  result: string;
  message: string;
}

interface changepasswordResponse {
  status: string;
  message: string;
}
const headers = {
  'Content-Type': 'application/json',
  'API-ClientID': appConfig.API_ClientID,
  'API-ClientSecret': appConfig.API_ClientSecret,
  Accept: 'application/json',
};

/**
 * Login API - sends username and password, returns decrypted response
 */
export const loginApiService = async (
  username: string,
  password: string,
  otpVerify: string
): Promise<DecryptedResponse> => {
  try {
    const encryptedBody = aesEncryptionService.encryptData({
      UserName: username,
      Password: password,
      OtpVerify: otpVerify,
      websiteid: "10",
      PwdToken:"T",
      machineip:""
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };


    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/userlogin`,
      requestBody,
      { headers }
    );

    if (!response.data?.encryptedBody) {
      throw new Error('Invalid response format: missing encryptedBody');
    }

    const decryptedResponse = aesEncryptionService.decryptData(response.data.encryptedBody);

    if (!decryptedResponse || !decryptedResponse.Result) {
      throw new Error('Invalid decrypted response structure');
    }

    // Cache response
    if (decryptedResponse.Result === "1") {
      sessionStorage.setItem('UserDetails', response.data.encryptedBody);
      sessionStorage.setItem('UserName', decryptedResponse.UserName);
      sessionStorage.setItem('Inst_id', decryptedResponse.InstId);
      sessionStorage.setItem('staff_id', decryptedResponse.User);
      sessionStorage.setItem('UserDetails', response.data.encryptedBody);
      sessionStorage.setItem('UserName', decryptedResponse.UserName);
      sessionStorage.setItem('staff_id', decryptedResponse.User);
      sessionStorage.setItem('Mobile', decryptedResponse.Mobile);
      sessionStorage.setItem('EmailId', decryptedResponse.EmailId);
      sessionStorage.setItem('CompName', decryptedResponse.CompName);
      sessionStorage.setItem('DOB', decryptedResponse.dob || "");
      sessionStorage.setItem('Department', decryptedResponse.user_dept || "");
      sessionStorage.setItem('Designation', decryptedResponse.user_desig || "");
      sessionStorage.setItem('EVerify', decryptedResponse.EVerify);
      sessionStorage.setItem('MVerify', decryptedResponse.MVerify);
      sessionStorage.setItem("CardUIData", JSON.stringify(decryptedResponse.CardUIData));
      sessionStorage.setItem('staff_inst_id', decryptedResponse.InstId);
    }

    return decryptedResponse;
  } catch (error: any) {
    sessionStorage.clear();
    if (error?.isAxiosError) {
  
      if (error.response) {
        console.error('Response Error - ',error)
        return {
          success: false,
          Message: error.response.data?.message || error.response.data || "Invalid response from API"
        } as DecryptedResponse;
      }
  
      if (error.request) {
        console.error('Request Error - ',error)
        return {
          success: false,          
          Message: "Network error. Check your connection."
        } as DecryptedResponse;
      }
    }
    console.error('Error - ',error)
    return {      
      success: false,
      Message: error.message || "Unexpected error"
    } as DecryptedResponse;
  }
};
/**
 * 
 * SLoginVieEM API - sends email or mobile to backend
 */
export const logOut = async (staffId: string): Promise<{ success: boolean }> => {
  try {
    const encryptedBody = aesEncryptionService.encryptData({
      staff_id: staffId,
      staff_inst_id:sessionStorage.getItem('staff_inst_id')
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/userlogout`,
      requestBody,
      { headers }
    );
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';    
    return { success: true };
  } catch (error: any) {
    console.error("logOut API Error:", error.message);
    return (error.message || "logOut failed. Please check the API.");
  }
};

/**
 * SLoginVieEM API - sends email or mobile to backend
 */
export const LoginVieEM = async (
  payload: { mobile?: string; email?: string },
  otplogin: string
): Promise<DecryptedResponse> => {
  try {

    const encryptedBody = aesEncryptionService.encryptData({
      ...(payload.mobile && { mobile: payload.mobile }),
      ...(payload.email && { email: payload.email }),
      OtpVerify: otplogin,
      websiteid: "10",
      machineip:""
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };


    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/loginVieotp`,
      requestBody,
      { headers }
    );

    if (!response.data?.encryptedBody) {
      throw new Error('Missing encryptedBody in response');
    }


    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    if (decrypted.Result === "1") {
      sessionStorage.setItem('UserDetails', response.data.encryptedBody);
      sessionStorage.setItem('UserName', decrypted.UserName);
      sessionStorage.setItem('staff_id', decrypted.User);
      sessionStorage.setItem('Mobile', decrypted.Mobile);
      sessionStorage.setItem('EmailId', decrypted.EmailId);
      sessionStorage.setItem('CompName', decrypted.CompName);
      sessionStorage.setItem('DOB', decrypted.dob || "");
      sessionStorage.setItem('Department', decrypted.user_dept || "");
      sessionStorage.setItem('Designation', decrypted.user_desig || "");
      sessionStorage.setItem('EVerify', decrypted.EVerify);
      sessionStorage.setItem('MVerify', decrypted.MVerify);
      sessionStorage.setItem("CardUIData", JSON.stringify(decrypted.CardUIData));
      sessionStorage.setItem('staff_inst_id', decrypted.InstId);
    }
    //console.log("decrypted", decrypted);
    return decrypted;
  } catch (error: any) {
    sessionStorage.clear();
    if (error?.isAxiosError) {
  
      if (error.response) {
        return {
          success: false,
          Message: error.response.data?.message || "API error occured"
        } as DecryptedResponse;
      }
  
      if (error.request) {
        return {
          success: false,
          Message: "Network error. Check your connection."
        } as DecryptedResponse;
      }
    }
  
    return {
      success: false,
      Message: error.message || "Unexpected error"
    } as DecryptedResponse;
  }
};

/**
 * Send OTP API - sends email or mobile to backend
 */
export const sendOtpLogin = async (
  payload: { mobile?: string; email?: string }
): Promise<{ success: boolean }> => {
  try {
    //console.log("payload", payload);

    const encryptedBody = aesEncryptionService.encryptData({
      email: payload.email || null,
      mobile: payload.mobile || null,
    });

    const requestBody = {
      application: "PSGLOGIN",
      date: new Date().toISOString().split("T")[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/otp/send`,
      requestBody,
      { headers }
    );

    if (!response.data?.encryptedBody) {
      throw new Error("Missing encryptedBody in response");
    }

    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    //console.log("sendOtpLogin-decrypted", decrypted)
    return {
      success: decrypted?.result === "1", // depending on your API response
    };
  } catch (error) {
    console.error("Send OTP Error:", error);
    return { success: false };
  }
};
/**
 * Verify OTP API - validates the OTP
 */
export const verifyOtp = async (
  payload: { mobile?: string; email?: string },
  otp: string,
  staff_id: string
): Promise<{ verified: boolean }> => {
  try {
    //console.log("payload", payload);
    //console.log("OTP", otp);
    const encryptedBody = aesEncryptionService.encryptData({
      ...(payload.mobile && { mobile: payload.mobile }),
      ...(payload.email && { email: payload.email }),
      userotp: otp,
      staff_id: staff_id,
      machineip: "",
      staff_inst_id:sessionStorage.getItem('staff_inst_id')
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/otp/verify`,
      requestBody,
      { headers }
    );

    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    return {
      verified: decrypted?.result === "1",
    };
  } catch (error: any) {
    console.error("verifyOtp API Error:", error.message);
    return (error.message || "verifyOtp failed. Please check the API.");
  }
};

/**
 * forget request API -  backend
 */
export const forgetrequest = async (
  username: string,
  payload: { mobile?: string; email?: string }
): Promise<ForgotRequestResponse> => {
  try {
    const encryptedBody = aesEncryptionService.encryptData({
      login_id: username,
      ...(payload.mobile && { mobile: payload.mobile }),
      ...(payload.email && { email: payload.email }),
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/resetrequest`,
      requestBody,
      { headers }
    );
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody) as ForgotRequestResponse;
    return decrypted;
  } catch (error: any) {
    console.error("forgetrequest API Error:", error.message);
    return (error.message || "forgetrequest failed. Please check the API.");
  }
};

export const PasswordRest = async (
  username: string,
  payload: { mobile?: string; email?: string },
  otp: string,
  password: string
): Promise<ForgotRequestResponse> => {
  try {
    const encryptedBody = aesEncryptionService.encryptData({
      login_id: username,
      userotp: otp,
      password: password,
      ...(payload.mobile && { mobile: payload.mobile }),
      ...(payload.email && { email: payload.email }),
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/resetpassword`,
      requestBody,
      { headers }
    );

    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody) as ForgotRequestResponse;
    return decrypted;
  } catch (error: any) {
    console.error("PasswordRest API Error:", error.message);
    return (error.message || "PasswordRest failed. Please check the API.");
  }
};

/** 
 *  Change password API 
 * **/

export const changepassword = async (
  staff_id: string,
  current_pwd: string,
  new_pwd: string,
  cnew_pwd: string
): Promise<changepasswordResponse> => {
  try {
    const encryptedBody = aesEncryptionService.encryptData({
      staff_id: staff_id,
      current_pwd: current_pwd,
      new_pwd: new_pwd,
      cnew_pwd: cnew_pwd,
      PwdToken:"T",
      staff_inst_id:sessionStorage.getItem('staff_inst_id')
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/changepassword`,
      requestBody,
      { headers }
    );

    if (!response.data?.encryptedBody) {
      throw new Error('Invalid response format: missing encryptedBody');
    }

    //const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody) as changepasswordResponse;
    const decryptedStr = aesEncryptionService.decryptData(response.data.encryptedBody);

    const decrypted =
      typeof decryptedStr === "string"
        ? JSON.parse(decryptedStr)
        : decryptedStr;

    return decrypted;
  } catch (error: any) {
    console.error('Change password Error:', error);
    throw new Error('Change password failed. Please try again.');
  }
};

export const getLoginHistory = async (
  staff_id: string,
  Inst_id: string,
): Promise<DecryptedResponse> => {
  try {
    const encryptedBody = aesEncryptionService.encryptData({
      staff_id: staff_id,
      InstId: Inst_id
    });

    const requestBody = {
      application: 'PSGLOGIN',
      date: new Date().toISOString().split('T')[0],
      encryptedBody,
    };

    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/GetUserLog`,
      requestBody,
      { headers }
    );

    if (!response.data?.encryptedBody) {
      throw new Error('Invalid response format: missing encryptedBody');
    }

    //const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody) as changepasswordResponse;
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);

    return decrypted;
  } catch (error: any) {
    console.error('Change password Error:', error);
    throw new Error('Change password failed. Please try again.');
  }
};